import React from "react";

const Constituency = ({ data }) => {
  const {office, constituency } = data || {};

  if (!office || !constituency) {
    return null;
  }

  const items = [
    ["LOCAL GOVERNMENT", constituency.local_government],
    ["CONSTITUENCY", constituency.constituency],
    ["WARD", constituency.ward],
    ["UNIT", constituency.unit],
    ["TOWN", constituency.town],
    ["STATE", constituency.state],
  ];

  return (
    <section
      className="constituency-section section-padding"
      id="constituency"
      aria-labelledby="constituency-title"
    >
      <div className="container constituency-grid">

        {/* CONTENT */}
        <div className="constituency-content">

          <p className="section-label">
            <span />
            THE CONSTITUENCY
          </p>

          <h2 id="constituency-title">
            Serving{" "}
            <em>
              {office.constituency ||
                constituency.constituency}
              .
            </em>
          </h2>
{/* 
          <p>
            The constituency is at the heart of the
            Honourable's legislative mandate. This
            platform provides information about
            representation, constituency activities
            and community engagement.
          </p> */}

          <div className="constituency-data">

            {items.map(([label, value]) => (
              <div key={label}>
                <small>{label}</small>
                <strong>{value || "—"}</strong>
              </div>
            ))}

          </div>

          <a
            href="#contact"
            className="btn btn-primary"
          >
            Connect With the Office
            <span aria-hidden="true">
              →
            </span>
          </a>

        </div>

        {/* VISUAL */}
        <div
          className="constituency-visual"
          role="img"
          aria-label={`Constituency visual showing ${constituency.town}, ${constituency.constituency}`}
        >
          <div className="map-placeholder">

            <div
              className="map-grid"
              aria-hidden="true"
            />

            <div className="map-center">

              <div
                className="map-pin"
                aria-hidden="true"
              >
                <span />
              </div>

              <div className="map-label">

                <strong>
                  {constituency.town}
                </strong>

                <small>
                  {constituency.constituency}
                </small>

              </div>

            </div>

            <div
              className="map-watermark"
              aria-hidden="true"
            >
              {constituency.state
                ?.replace(" State", "")
                .toUpperCase()}
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Constituency;